<template>
  <!-- 模板 -->
  <div class="container">
    <div class="top clearfix">
      <div class="col-xs-12 col-sm-6 top-left " >
        <img src="@/assets/image/pan.png" alt="" v-if="numberDetail.title">
        <span>{{numberDetail.title}}</span>
      </div>

      <div class="col-xs-12 col-sm-6 top-right ">
        <ul>
          <li>
            <router-link to="titbits">比賽花絮</router-link>
          </li>
          <li>
            <a class="is-check">歷届花絮</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="the-hr" ></div> -->

    <div class="content">
      <div class="visible-xs col-xs-10 col-xs-offset-1 none-padding">
        <div class="top-tibits ">
          <img :src="numberDetail.thumbnail_url" alt="">
          <span>{{numberDetail.title}}</span>
        </div>
      </div>

      <div class="col-xs-12">
        <slot name="banner"></slot>
      </div>
      <div class="col-xs-12 col-sm-9 content-left ">
        <img class="col-xs-12 content-banner" :src="numberDetail.banner_url" alt="">
        <div class="col-xs-12 content-text" v-if="numberDetail.winner">
          <div v-html="numberDetail.winner"></div>
        </div>  <!-- 获奖名单结束 -->
        <div class="col-xs-12 content-video" v-if="videoList.length > 0">
          <div>
            <span class="news-title">影片</span>
            <div class="transverse-line"></div>
          </div>
          <div class="col-xs-10 col-xs-offset-1 video-bg " v-for="(video,index) in videoList" :key="video.id" @click="showVideo(video.youtube_id,index)">
            <img :src="'http://img.youtube.com/vi/' + video.youtube_id + '/default.jpg'">
            <div class="video-btn"><img src="@/assets/image/video_btn.png"></div>
            <div class="video-footer">{{video.file_names}}</div>
          </div>

        </div>   <!-- 影片结束 -->
        <div class="col-xs-12 content-photo" v-if="photoList.length > 0">
          <span class="news-title">相片</span>
          <div class="transverse-line"></div>
          <div class="col-xs-12 col-md-offset-1 none-padding">
            <!--<div class="col-xs-6 col-sm-3 photo-bg">-->
              <!--<img src="@/assets/image/second_bg.png" alt="">-->
              <!--<div class="p-title">第26屆滙業盃總決賽精華片段</div>-->
            <!--</div>-->
            <div v-for="(photo,index) in photoList" :key="photo.id" @click="showAlert(index)" class="col-xs-6 col-sm-3 photo-bg">
              <img :src="photo.album[0].photo_urls" alt="">
              <div class="p-title">{{photo.type_name}}</div>
            </div>
          </div>

        </div>    <!-- 相片结束 -->
      </div>
      <div class="col-xs-12 col-sm-3 content-right">
        <div class="one-tibits" v-for="(number) in numberList" :key="number.id" :class="current == number.id ? 'activite' : ''" @click="selectFeautre(number.id,number.cate_id)">
          <img :src="number.thumbnail_url" alt="">
          <span>{{number.title}}</span>
        </div>
      </div>
    </div>
    <!--相册轮播图-->
    <album ref="photoAlert"></album>
    <!--视频播放页面-->
    <album-video ref="videoAlert"></album-video>
  </div>
</template>
<script>
import AlbumPhoto from '../titbits/albumPhoto'
import AlbumVideo from '../titbits/albumVideo'
export default {
  components: {
    'album': AlbumPhoto,
    'album-video': AlbumVideo
  },
  data () {
    return {
      'cate_id': '',    // 届数
      'numberList': [],    // 届数列表
      'videoList': [],     // 视频列表
      'photoList': [],      // 相册列表
      'numberDetail': [],        // 本届详细
      'current': 0
    }
  },
  methods: {
    // 获得所有的届数列表
    allList: function () {
      var that = this
      this.$axios.get('/award/list')
        .then(function (respone) {
          that.numberList = respone.data.data
          // console.log(that.numberList)
          // console.log('111',that.$route.params.id)
          // 判断是从比赛花絮点击跳转过来还是直接点击【历届花絮或刷新】
          var id = that.$route.params.id ? that.$route.params.id : that.numberList[0].id
          var cateId = that.$route.params.cate_id ? that.$route.params.cate_id : that.numberList[0].cate_id
          that.selectFeautre(id, cateId)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 获得当前届数的相册和视频
    Feautre: function () {
      this.goTop()
      var that = this
      var url = this.cate_id ? '?cate_id=' + this.cate_id : ''
      this.$axios.get('/award/titbits' + url)
        .then(function (respone) {
          that.videoList = respone.data.data.video
          that.photoList = respone.data.data.photo
          // console.log(that.videoList)
          // console.log(that.photoList)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 获得某一届数的视频和届数列表
    selectFeautre: function (id, cateId) {
      this.current = id
      this.cate_id = cateId
      this.Feautre()
      var that = this
      this.$axios.get('/award/one?id=' + id)
        .then(function (respone) {
          that.numberDetail = respone.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 傳入相冊數組的下標
    showAlert: function (key) {
      if (document.body.clientWidth >= 768) {
        this.$refs.photoAlert.show(this.photoList[key])
      } else {
        this.$router.push({name: 'mobile-album', query: {type_id: this.photoList[key].id}})
      }
    },
    showVideo: function (youtubeId, index) {
      this.$refs.videoAlert.show(index, youtubeId, this.videoList)
    }
  },
  created: function () {
    this.allList()
  },
  mounted: function () {
    this.selectFeautre(this.$route.query.id, this.$route.query.cate_id)
  },
  updated () {
    $('.content-text img').attr('preview', 2)
    this.$previewRefresh()
  }
}
</script>
<style scoped>
  .container {
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
    border-radius: 5px;
    margin-top: 80px;
    /*min-height: 900px;*/
    padding: 0px;
  }

  .container hr {
    margin-top: 0px;
    height: 5px;
    background: #617BE4;
  }

  .top {
    font-family: PingFangSC-Medium;
    color: #565656;
    border-bottom: 5px solid #617BE4;
    padding-bottom: 5px;
  }
  .top .is-check{
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }

  .top .top-left {
    display: inline-block;
    margin-top: 5px;
    padding-bottom: 8px;
    padding-top: 8px;
  }

  .top .top-left img {
    margin-bottom: 5px;
  }

  .top .top-left span {
    font-size: 24px;
  }

  .top .top-right {
    text-align: right;
    margin-top: 10px;
    padding-top: 5px;
  }

  .top ul li {
    display: inline-block;
    margin-right: 20px;
    font-size: 20px;
  }

  .top ul li a {
    padding: 2px 15px;
    color: #565656;
  }

  .top ul li a:hover, .top ul li a:focus {
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }

  .content .content-left {
    /*min-height: 800px;*/
    border-right: 1px solid #DCDEE1;
    padding: 0px;
    overflow: hidden;
  }

  .content .content-left .content-banner {
    padding: 0px;
    width: 100%;
    max-height: 360px;
  }

  .content .content-left .content-text {
    min-height: 200px;
    margin-top: 20px;
    margin-bottom: 20px;
    /*background-color: #000;*/
  }

  .content-right{
    margin-top: 10px;
  }
  .one-tibits {
    position: relative;
    width: 100%;
    height: 80px;
    margin-bottom: 20px;
    border: 1px solid #C0C2C5;
    border-radius: 10px;
    display: inline-block;
    cursor: pointer;
  }

  .one-tibits:hover {
    border: 4px solid #617BE4;
    border-radius: 10px;
  }
  /*.one-tibits:hover span{*/
    /*color: #526add;*/
  /*}*/

  .one-tibits img, .top-tibits img {
    width: 35%;
    height: 100%;
    border-radius: 8px;
    display: inline-block;
  }

  .one-tibits span, .top-tibits span {
    width: 65%;
    margin-top: 10px;
    display: inline;
    word-break: normal;
    overflow: hidden;
    vertical-align: middle;
    float: right;
  }

  .top-tibits {
    position: relative;
    /*width: 320px;*/
    height: 90px;
    /*margin-left: 20px;*/
    margin-bottom: 20px;
    margin-top: 10px;
    border: 4px solid #617BE4;
    border-radius: 10px;
    display: inline-block;
  }

  /*三角形*/
  .top-tibits::before {
    content: " ";
    position: absolute;
    bottom: -35%;
    left: 25%;
    margin-top: -13px;
    border-width: 13px;
    border-style: solid;
    border-color: #617BE4 transparent transparent transparent;
  }

  .content-photo,.content-video {
    margin: 20px auto;
    /*margin-bottom: 20px;*/
  }

  .activite{
    border: 4px solid #617BE4;
    border-radius: 10px;
  }
  .activite::before{
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -13px;
    border-width: 13px;
    border-style: solid;
    border-color: transparent #617BE4 transparent transparent;
  }

  @media (min-width: 768px) {
    /*三角形*/
    .one-tibits:hover::before {
      content: " ";
      position: absolute;
      top: 50%;
      right: 100%;
      margin-top: -13px;
      border-width: 13px;
      border-style: solid;
      border-color: transparent #617BE4 transparent transparent;
    }
  }

  @media (max-width: 768px) {

    .top .top-left{
      padding-right: 0px;
    }
    /*.top .top-right{*/
      /*width: 40%;*/
    /*}*/

    .top .top-left span {
      font-size: 24px;
    }
    .top .top-right {
      float: right;
      text-align: center;
    }

    .top ul {
      /*padding: 0px;*/
    }
    .top ul li {
      font-size: 20px;
    }

    .the-hr {
      margin-top: 55px;
    }
  }

  @media (max-width: 767px) {
    .activite::before{
      border-color: transparent transparent transparent transparent;
    }
    .top ul li {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/titbits/allTitbits.vue